import React from 'react'
import {MdHome, MdKeyboardArrowRight} from 'react-icons/md'
import classnames from 'classnames'
import Link from 'next/link'

import styles from './styles.module.css'

export default function Breadcrumbs({category}) {
  return (
    <div className={styles.breadcrumbs}>
      <Link href="/" className={styles.forceColor}>

        <MdHome size="1.5em" />

      </Link>
      <MdKeyboardArrowRight className={styles.spaceLeft} />
      {category.parent ? (
        <div>
          <Link
            href={`/pedir/category/${category.parent._id}`}
            prefetch={false}
            className={classnames(styles.forceColor, styles.spaceLeft)}>

            {category.parent.name}

          </Link>
          <MdKeyboardArrowRight className={styles.spaceLeft} />
        </div>
      ) : null}
      <span className={classnames(styles.spaceLeft, styles.primaryColor)}>{category.name}</span>
    </div>
  );
}
